/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type FGwpPromotionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FGwpPromotionsQuery = { __typename?: 'QueryRoot', metaobject?: { __typename?: 'Metaobject', list?: { __typename?: 'MetaobjectField', references?: { __typename?: 'MetafieldReferenceConnection', nodes: Array<{ __typename?: 'Collection' } | { __typename?: 'GenericFile' } | { __typename?: 'MediaImage' } | { __typename: 'Metaobject', proCode?: { __typename?: 'MetaobjectField', value?: string | null } | null, consumerCode?: { __typename?: 'MetaobjectField', value?: string | null } | null, proGifts?: { __typename?: 'MetaobjectField', value?: string | null } | null, consumerGifts?: { __typename?: 'MetaobjectField', value?: string | null } | null } | { __typename?: 'Model3d' } | { __typename?: 'Page' } | { __typename?: 'Product' } | { __typename?: 'ProductVariant' } | { __typename?: 'Video' }> } | null } | null } | null };

export declare const fGWPPromotions: import("graphql").DocumentNode;

export const FGwpPromotionsDocument = /*#__PURE__*/ `
    query fGWPPromotions {
  metaobject(handle: {handle: "fgwp-promotions", type: "fgwpPromotions"}) {
    list: field(key: "list") {
      references(first: 10) {
        nodes {
          ... on Metaobject {
            __typename
            proCode: field(key: "proCode") {
              value
            }
            consumerCode: field(key: "consumerCode") {
              value
            }
            proGifts: field(key: "proGifts") {
              value
            }
            consumerGifts: field(key: "consumerGifts") {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const useFGwpPromotionsQuery = <
      TData = FGwpPromotionsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: FGwpPromotionsQueryVariables,
      options?: UseQueryOptions<FGwpPromotionsQuery, TError, TData>
    ) =>
    useQuery<FGwpPromotionsQuery, TError, TData>(
      variables === undefined ? ['fGWPPromotions'] : ['fGWPPromotions', variables],
      fetcher<FGwpPromotionsQuery, FGwpPromotionsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, FGwpPromotionsDocument, variables, options),
      options
    );

useFGwpPromotionsQuery.getKey = (variables?: FGwpPromotionsQueryVariables) => variables === undefined ? ['fGWPPromotions'] : ['fGWPPromotions', variables];
;

useFGwpPromotionsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: FGwpPromotionsQueryVariables, options?: RequestInit['headers']) => fetcher<FGwpPromotionsQuery, FGwpPromotionsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, FGwpPromotionsDocument, variables, options);